module.exports = __webpack_public_path__ + "static/media/wwshipping.b930fcbd.svg";